export default __webpack_public_path__ + "static/media/22-serious-face-with-symbols-covering-mouth_1f92c.7bba745f.png";